/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import {
    CashboxLocationData,
    HistoryLocationsList,
    HistoryLocationsQueryParams,
    LocationsListItem,
} from '../../../api/cashBoxes/cashBoxesClient.typings';
import {
    CashBoxGpsTrackingTabAction,
    CashBoxGpsTrackingTabActionType,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxGpsTrackingTabActions';
import moment from 'moment';
import { defaultHistoryPaginationLimit, today } from '../cashboxDetailsReducer';

export interface CashBoxGpsTrackingTabState {
    isLoadingLocationData: boolean;
    locationData: CashboxLocationData;
    isLoadingHistoryLocations: boolean;
    historyLocations?: HistoryLocationsList;
    historyLocationsQueryParams: HistoryLocationsQueryParams;
    isLoadingTrackingLocations: boolean;
    gpsTrackingLocations?: LocationsListItem[];
    trackingAccuracy: number;
}
const initialState: CashBoxGpsTrackingTabState = {
    isLoadingLocationData: false,
    locationData: null,
    isLoadingHistoryLocations: false,
    historyLocations: {
        count: 0,
        items: [],
    },
    historyLocationsQueryParams: {
        limit: defaultHistoryPaginationLimit,
        offset: 0,
        fromInsertedDateAtUtc: today.clone().utc().subtract(30, 'day').format(),
        toInsertedDateAtUtc: moment(new Date()).endOf('day').utc().format(),
    },
    isLoadingTrackingLocations: false,
    gpsTrackingLocations: [],
    trackingAccuracy: null,
};

export function cashBoxGpsTrackingTabReducer(
    state: CashBoxGpsTrackingTabState = initialState,
    action: CashBoxGpsTrackingTabAction,
): CashBoxGpsTrackingTabState {
    switch (action.type) {
        case CashBoxGpsTrackingTabActionType.OPEN_GPS_TRACKING_TAB:
            return {
                ...state,
                isLoadingLocationData: true,
                isLoadingHistoryLocations: true,
            };

        case CashBoxGpsTrackingTabActionType.FETCH_CASHBOX_LOCATION_DATA_SUCCESS:
            return {
                ...state,
                isLoadingLocationData: false,
                locationData: action.payload,
            };

        case CashBoxGpsTrackingTabActionType.FETCH_CASHBOX_LOCATION_DATA_ERROR:
            return {
                ...state,
                isLoadingLocationData: false,
            };

        case CashBoxGpsTrackingTabActionType.APPLY_HISTORY_LOCATIONS_FILTERING:
            return {
                ...state,
                isLoadingHistoryLocations: true,
                historyLocationsQueryParams: {
                    ...action.payload.params,
                },
                gpsTrackingLocations: [],
            };

        case CashBoxGpsTrackingTabActionType.FETCH_CASHBOX_HISTORY_LOCATIONS_PAGE_SUCCESS: {
            return {
                ...state,
                isLoadingHistoryLocations: false,
                historyLocations: action.payload.list,
            };
        }

        case CashBoxGpsTrackingTabActionType.FETCH_CASHBOX_HISTORY_LOCATIONS_PAGE_ERROR:
            return {
                ...state,
                isLoadingHistoryLocations: false,
            };

        case CashBoxGpsTrackingTabActionType.FETCH_CAHSBOX_GPS_TRACKING_START:
            return {
                ...state,
                isLoadingTrackingLocations: true,
            };

        case CashBoxGpsTrackingTabActionType.FETCH_CASHBOX_GPS_TRACKING_SUCCESS: {
            return {
                ...state,
                isLoadingTrackingLocations: false,
                gpsTrackingLocations: action.payload.list && action.payload.list.items ? action.payload.list.items : [],
                trackingAccuracy: action.payload.list.accuracy,
            };
        }

        case CashBoxGpsTrackingTabActionType.FETCH_CASHBOX_GPS_TRACKING_ERROR:
            return {
                ...state,
                isLoadingTrackingLocations: false,
            };

        case CashBoxGpsTrackingTabActionType.EXIT_GPS_TRACKING_TAB:
            return {
                ...state,
                locationData: null,
                trackingAccuracy: null,
                historyLocations: initialState.historyLocations,
                gpsTrackingLocations: [],
            };

        default:
            break;
    }
    return state;
}
